module.exports = __webpack_public_path__ + "static/media/peluqueria.751cb16b.jpg";